import { render, staticRenderFns } from "./dataFromDetail.vue?vue&type=template&id=f5718806&scoped=true&"
import script from "./dataFromDetail.vue?vue&type=script&lang=js&"
export * from "./dataFromDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5718806",
  null
  
)

export default component.exports